// Confirmation Modal Component

import React from 'react';
import '../MasterData/MasterData.css';

interface ConfirmationModalProps {
  isOpen: boolean;
  title: string;
  message: React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  type?: 'danger' | 'warning' | 'info' | 'success';
  hideCancel?: boolean;
}

export function ConfirmationModal({
  isOpen,
  title,
  message,
  confirmText = 'Bestätigen',
  cancelText = 'Abbrechen',
  onConfirm,
  onCancel,
  type = 'warning',
  hideCancel = false
}: ConfirmationModalProps) {
  if (!isOpen) return null;

  const getIconAndColor = () => {
    switch (type) {
      case 'danger':
        return { icon: '🗑️', color: '#dc3545', bgColor: '#ffebee' };
      case 'warning':
        return { icon: '⚠️', color: '#f59e0b', bgColor: '#fef3c7' };
      case 'info':
        return { icon: 'ℹ️', color: '#3b82f6', bgColor: '#dbeafe' };
      case 'success':
        return { icon: '✅', color: '#28a745', bgColor: '#e8f5e9' };
      default:
        return { icon: '⚠️', color: '#f59e0b', bgColor: '#fef3c7' };
    }
  };

  const { icon, color, bgColor } = getIconAndColor();

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: '500px' }}
      >
        <div className="modal-header">
          <h2>{title}</h2>
          <button className="modal-close" onClick={onCancel}>×</button>
        </div>

        <div className="modal-body">
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
              padding: '20px 0',
              gap: '20px'
            }}
          >
            <div
              style={{
                fontSize: '64px',
                lineHeight: 1,
                filter: type === 'danger' ? 'drop-shadow(0 2px 4px rgba(220, 53, 69, 0.2))' :
                        type === 'warning' ? 'drop-shadow(0 2px 4px rgba(245, 158, 11, 0.2))' :
                        'drop-shadow(0 2px 4px rgba(59, 130, 246, 0.2))'
              }}
            >
              {icon}
            </div>
            <div style={{
              width: '100%',
              fontSize: '15px',
              color: '#374151',
              lineHeight: 1.6,
              fontWeight: 400
            }}>
              {typeof message === 'string' ? <p style={{ margin: 0 }}>{message}</p> : message}
            </div>
          </div>
        </div>

        <div className="modal-footer">
          {!hideCancel && (
            <button
              type="button"
              onClick={onCancel}
              className="btn-secondary"
            >
              {cancelText}
            </button>
          )}
          <button
            type="button"
            onClick={onConfirm}
            className="btn-primary"
            style={{
              backgroundColor: type === 'danger' ? '#dc3545' : type === 'success' ? '#28a745' : undefined,
              borderColor: type === 'danger' ? '#dc3545' : type === 'success' ? '#28a745' : undefined
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
